import React, { Component } from "react";
import { GET, POST, tokens, loading, profile, alert, t } from "../../components/CustomComponent.js";
import Language from "../../components/Language.js";
import LOGO from "../../assets/images/logo.png";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import { clearStorageKeepLang } from "../../utils/backendMessage";

export default class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: "GUSCO Service Co., Ltd.",
    };
  }

  componentDidMount() {
    loading(false);
  }

  Logout = async () => {
    if (
      await alert(
        "",
        "warning",
        t("confirm"), // ใช้ t()
        t("logout_ask"), // ใช้ t()
        "Logout",
        "cancel",
      )
    ) {
      loading(true);
      let result = await POST("auth/logout", null);
      if (result?.status) {
        clearStorageKeepLang();
        window.location.href = "/";
      }
      loading(false);
    }
  };

  render() {
    const { companyName } = this.state;

    return (
        <div
            className="min-vh-100 d-flex flex-column text-white font-sans"
            style={{
                background: "linear-gradient(180deg, #1461bd 0%, #2985f2 100%)",
            }}
        >
            {/* Top Bar - Company Selector */}
            <div className="w-100 d-flex justify-content-between align-items-center px-4 py-2" style={{ backgroundColor: "rgba(0,0,0,0.1)" }}>
                <div className="d-flex align-items-center" style={{ fontSize: "0.85rem" }}>
                    <div className="me-2 rounded bg-white-light p-1 px-2 d-flex align-items-center justify-content-center">
                        <span className="icon">{"\uf1ad"}</span>
                    </div>
                    <div>
                        <div className="text-white-50" style={{ fontSize: "0.75rem" }}>
                            {t("current_company")}
                        </div>
                        <div className="fw-bold">{companyName}</div>
                    </div>
                </div>
                <div className="d-none d-xl-flex align-items-center">
                    <button className="btn btn-sm text-white border-0 shadow-none">
                        <span className="icon me-2">{"\uf362"}</span> {t("change_company")}
                    </button>
                    <div className="hpx-40 mx-3" style={{ width: 1, backgroundColor: "var(--bs-gray-2)" }} />
                    <div className="d-none d-xl-flex align-items-center text-start user-badge px-2 py-1 rounded-lg">
                        <span className="user-avatar me-2 wpx-32 hpx-32 d-flex align-items-center justify-content-center" style={{ fontSize: "0.75rem" }}>
                            {profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                        </span>
                        <div className="pe-2">
                            <div className="text-14 fw-semibold text-dark">{profile?.full_name || "Username"}</div>
                            <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                                {profile?.role?.name || profile?.user_type?.replaceAll("_", " ") || "User"}
                            </div>
                        </div>
                        <button className="btn btn-sm border-0 p-2 text-dark" style={{ opacity: 0.7 }} onClick={() => this.Logout()} title="Logout">
                            <span className="icon">{"\uf08b"}</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Header */}
            <div className="container-fluid px-4 py-3 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <div className="bg-white rounded p-1 me-3 d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px" }}>
                        <img src={LOGO} alt="logo" className="img-fluid" style={{ maxHeight: "100%" }} />
                    </div>
                    <div>
                        <h4 className="mb-0 fw-bold">GUSCO</h4>
                        <small className="d-none d-md-block">Computerized Maintenance Management System</small>
                    </div>
                </div>
                <Language />
            </div>

            {/* Welcome Section */}
            <div className="container text-center mt-4 mb-5">
                <h1 className="display-6 fw-bold mb-3">{t("welcome_title")}</h1>
                <p className="lead mb-4">{t("welcome_sub")}</p>
                <div className="d-inline-flex align-items-center bg-white-light rounded-pill px-4 py-2 border border-white">
                    <span className="icon me-2">{"\uf1ad"}</span> {companyName}
                </div>
            </div>

            {/* Portals Cards Grid */}
            <div className="container mb-5">
                <div className="row g-4">
                    {/* Admin Portal */}
                    <div className="col-12 col-md-6 col-xl-3">
                        <div className="card h-100 border-0 rounded-4 shadow-lg p-4 text-center cursor-pointer transition-hover" onClick={() => (window.location.href = "/ad/dashboard")}>
                            <div className="bg-primary text-light rounded-4 mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "80px", height: "80px" }}>
                                <span className="icon text-24">{"\uf505"}</span>
                            </div>
                            <h5 className="fw-bold text-dark">{t("admin_portal")}</h5>
                            <p className="text-muted small mb-4">{t("admin_desc")}</p>
                            <div className="mt-auto">
                                <button className="btn btn-link text-primary text-decoration-none fw-bold w-100">
                                    {t("enter")} <span className="icon ms-1">{"\uf061"}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Customer Portal */}
                    <div className="col-12 col-md-6 col-xl-3">
                        <div className="card h-100 border-0 rounded-4 shadow-lg p-4 text-center cursor-pointer transition-hover" onClick={() => (window.location.href = "/cs/dashboard")}>
                            <div className="bg-success text-light rounded-4 mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "80px", height: "80px" }}>
                                <span className="icon text-24">{"\uf1ad"}</span>
                            </div>
                            <h5 className="fw-bold text-dark">{t("customer_portal")}</h5>
                            <p className="text-muted small mb-4">{t("customer_desc")}</p>
                            <div className="mt-auto">
                                <button className="btn btn-link text-success text-decoration-none fw-bold w-100">
                                    {t("enter")} <span className="icon ms-1">{"\uf061"}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Mobile Service Portal */}
                    <div className="col-12 col-md-6 col-xl-3">
                        <div className="card h-100 border-0 rounded-4 shadow-lg p-4 text-center cursor-pointer transition-hover" onClick={() => (window.location.href = "/mb/mobile")}>
                            <div className="bg-warning text-light rounded-4 mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "80px", height: "80px" }}>
                                <span className="icon text-24">{"\uf3ce"}</span>
                            </div>
                            <h5 className="fw-bold text-dark">{t("mobile_portal")}</h5>
                            <p className="text-muted small mb-4">{t("mobile_desc")}</p>
                            <div className="mt-auto">
                                <button className="btn btn-link text-warning text-decoration-none fw-bold w-100">
                                    {t("enter")} <span className="icon ms-1">{"\uf061"}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Warehouse Portal */}
                    <div className="col-12 col-md-6 col-xl-3">
                        <div className="card h-100 border-0 rounded-4 shadow-lg p-4 text-center cursor-pointer transition-hover" onClick={() => (window.location.href = "/wh/dashboard")}>
                            <div
                                className="bg-purple text-light rounded-4 mx-auto d-flex align-items-center justify-content-center mb-3"
                                style={{ width: "80px", height: "80px", backgroundColor: "#e2d3f5" }}
                            >
                                <span className="icon text-24">{"\uf494"}</span>
                            </div>
                            <h5 className="fw-bold text-dark">{t("warehouse_portal")}</h5>
                            <p className="text-muted small mb-4">{t("warehouse_desc")}</p>
                            <div className="mt-auto">
                                <button className="btn btn-link text-decoration-none fw-bold w-100" style={{ color: "#8e44ad" }}>
                                    {t("enter")} <span className="icon ms-1">{"\uf061"}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* System Management */}
            <div className="container mb-5">
                <div className="text-center mb-3">
                    <small className="text-white-50 fw-bold">{t("sys_manage")}</small>
                    <div className="border-bottom border-white w-25 mx-auto mt-2"></div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <div className="card border-0 rounded-4 shadow-sm p-2 cursor-pointer transition-hover" onClick={() => (window.location.href = "/su/companies")}>
                            <div className="card-body d-flex align-items-center">
                                <div className="bg-dark rounded-3 d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                                    <span className="icon text-white text-24">{"\uf1ad"}</span>
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="fw-bold text-dark mb-1">{t("manage_comp")}</h6>
                                    <p className="text-muted small mb-0" style={{ fontSize: "0.8rem" }}>
                                        {t("manage_comp_desc")}
                                    </p>
                                </div>
                                <div className="ms-3 text-muted">
                                    <span className="icon">{"\uf061"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Feature Cards */}
            <div className="container mt-auto mb-4">
                <div className="row g-3">
                    <div className="col-12 col-md-4">
                        <div className="bg-white-light rounded-4 p-4 text-center border border-white h-100">
                            <div className="bg-white text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "40px", height: "40px" }}>
                                <span className="icon">{"\uf017"}</span>
                            </div>
                            <h6 className="fw-bold">{t("realtime")}</h6>
                            <small className="opacity-75">{t("realtime_desc")}</small>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="bg-white-light rounded-4 p-4 text-center border border-white h-100">
                            <div className="bg-white text-success rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "40px", height: "40px" }}>
                                <span className="icon">{"\uf201"}</span>
                            </div>
                            <h6 className="fw-bold">{t("analysis")}</h6>
                            <small className="opacity-75">{t("analysis_desc")}</small>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="bg-white-light rounded-4 p-4 text-center border border-white h-100">
                            <div className="bg-white text-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "40px", height: "40px" }}>
                                <span className="icon">{"\uf3cd"}</span>
                            </div>
                            <h6 className="fw-bold">{t("mobile_support")}</h6>
                            <small className="opacity-75">{t("mobile_support_desc")}</small>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="text-center py-4 mt-auto">
                <small className="opacity-80">
                    GUSCO Version {global.version} - Multi-Company Edition
                    <br />
                    Computerized Maintenance Management System
                </small>
            </div>
        </div>
    );
  }
}